// GENERATED by scripts/build-icons.mjs from icons/at-sign.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const AtSign = createIcon('at-sign', [
  ['circle', { cx: "12", cy: "12", r: "4" }],
  ['path', { d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8" }],
])
